/* eslint-disable no-restricted-globals */
export const init = () => {
  if (tc_vars.env_template !== 'product') return;

  /* ENHANCED E-COMMERCE - ADD TO CART */

  const fwk = CUBE.Analytics;

  /*
   * 	ADD TO CART - From 'AddToCart' button
   */
  const eventAddToCart = fwk.utils.getEvent(
    'addToCart',
    AnalyticsConstants.trackers.product.conversion.name
  );
  if (eventAddToCart) {
    eventAddToCart.postAction(($element, data, jqEvent, jqData, event) => {
      // Check if size is selected :
      // ( inspired from product-conversion.js #_addToCart )

      const sizeSelection = document.querySelector('.sizes__size.sizes__size--selected');
      if (sizeSelection) {
        const sizeInfo = sizeSelection.querySelector('.sizes__info');
        if (sizeInfo && sizeInfo.innerText.trim()) {
          // If size is selected : Send EnhancedEcommerce Informations
          event.options.action = 'AddToCart';
          const model = fwk.utils.productpage.getModel();

          const ecInfo = CUBE.Analytics.utils.getProperty(
            AnalyticsConstants.enhanced.actual,
            undefined
          );
          if (
            typeof ecInfo === 'object' &&
            (model.category === undefined || model.category === '')
          ) {
            model.category = ecInfo.category;
          }
          if (
            typeof ecInfo === 'object' &&
            (model.variant === undefined || model.variant === '')
          ) {
            model.variant = ecInfo.variant;
          }
          fwk.enhanced.sendAddToCart(model);
        }
      } else {
        // If size is not selected : Change event Action :
        event.options.action = 'AlertAddToCartNoSizeSelected';
      }

    });
  }
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-4-add-to-cart.js